import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import DoctorInterestsModal, {
  getDoctorInterestsStorageKey,
} from './DoctorInterestsModal';

const DoctorInterestsGate = () => {
  const { user, usuarioConCedula, refreshUsuarioConCedula } = useAuth();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (user?.authSource !== 'habeas-data') return;
    if (!usuarioConCedula?.id) return;

    const storageKey = getDoctorInterestsStorageKey(usuarioConCedula.id);
    const alreadyAssigned = localStorage.getItem(storageKey) === 'true';

    if (!alreadyAssigned) {
      setShowModal(true);
    }
  }, [user?.authSource, usuarioConCedula?.id]);

  const handleClose = () => setShowModal(false);

  const handleSuccess = async () => {
    await refreshUsuarioConCedula?.();
  };

  if (!showModal) return null;

  return (
    <DoctorInterestsModal
      open={showModal}
      onClose={handleClose}
      userId={usuarioConCedula?.id}
      onSuccess={handleSuccess}
    />
  );
};

export default DoctorInterestsGate;
